import { translate } from "app/filters/i18nFilter";
import { NOT_RANK_POSITION } from "app/pages/digital-marketing/keywords-campaigns/reports/shared/RTSharedConsts";
import type { TrendReportTableViewModesConfigs } from "app/pages/digital-marketing/keywords-campaigns/reports/trend-report/TrendReportsTypes";
import { TrendReportTableViewModes } from "app/pages/digital-marketing/keywords-campaigns/reports/trend-report/TrendReportsTypes";

export enum ETrendReportTablePresets {
    MOVED_TO_FIRST = "movedToTopKeywordsLastDate",
    DROPPED_FROM_FIRST = "droppedFrom1",
    MOVED_TOP_3 = "movedTop3",
    MOVED_TOP_10 = "movedTop10",
    DROPPED_TO_SECOND = "droppedToSecondPage",
    TRAFFIC_DRIVERS = "topKeywordsLastDate",
}

export interface ITrendReportPresetsDataSelection {
    id: ETrendReportTablePresets;
    previousPosition?: string;
    position: string;
}

export const TABLE_SELECTION_PROPERTY = "globalIndex";
export const TREND_REPORT_EXCEL_LINK = "/widgetApi/KeywordsResearch/TrendResearchExcel/Excel";
export const POSITIONS_COLUMN_PREFIX = "position";
export const SERP_STATUS_COLUMN_PREFIX = "serp";
export const TARGET_URL_COLUMN_PREFIX = "targetUrl";
export const TREND_REPORT_TABLE_STATE_KEY = "TrendReportTable";
export const TREND_REPORT_TABLE_SELECTION_KEY = "keyword";

export const trendReportViewModes: TrendReportTableViewModesConfigs[] = [
    {
        get title() {
            return translate("rankTracker.trend.viewMode.positions");
        },
        id: TrendReportTableViewModes.positions,
    },
    {
        get title() {
            return translate("rankTracker.trend.viewMode.targetUrl");
        },
        id: TrendReportTableViewModes.targetUrl,
    },
    {
        get title() {
            return translate("rankTracker.trend.viewMode.serpFeatures");
        },
        id: TrendReportTableViewModes.serpFeatures,
    },
];

export const trendReportPresetsSelectionConfig: ITrendReportPresetsDataSelection[] = [
    {
        id: ETrendReportTablePresets.MOVED_TO_FIRST,
        previousPosition: `2-${NOT_RANK_POSITION}`,
        position: "1-1",
    },
    {
        id: ETrendReportTablePresets.DROPPED_FROM_FIRST,
        previousPosition: "1-1",
        position: `2-${NOT_RANK_POSITION}`,
    },
    {
        id: ETrendReportTablePresets.MOVED_TOP_3,
        previousPosition: `4-${NOT_RANK_POSITION}`,
        position: "1-3",
    },
    {
        id: ETrendReportTablePresets.MOVED_TOP_10,
        previousPosition: `11-${NOT_RANK_POSITION}`,
        position: "1-10",
    },
    {
        id: ETrendReportTablePresets.DROPPED_TO_SECOND,
        previousPosition: "1-10",
        position: "11-20",
    },
    {
        id: ETrendReportTablePresets.TRAFFIC_DRIVERS,
        previousPosition: null,
        position: "1-1",
    },
];

export const ZERO_VALUE_REPLACEMENT = "-";
export const CELL_VALUE_FORMAT = "absNumber";
export enum EPositionFilterItems {
    ORGANIC = "organic",
    UNIVERSAL = "universal",
}
export const TREND_REPORT_POSITION_FILTER_PREFERENCES_KEY = "TrendReportPositionFilter";
export const TREND_REPORT_TABLE_COLUMNS_PREFERENCES_KEY = "trendReportTableColumns";
